<!-- progress-report.component.html -->
<div class="bg-white rounded-lg shadow-sm p-6 w-full">


  <!-- Graphique (hauteur agrandie) -->
  <div class="h-64">
    <canvas #barChart></canvas>
  </div>
</div>


